export const COLORS = {
  textLightGrey: '##888B90',
  textLightGray: '#888B90',
  textDarkGray: '#888B90',
  textDarkGrey: '##888B90',
  darkBg: '#050528',
  drawerBg: '#313131',
  darkBox: '#313131',
  darkBoxOpacity: '#34314022',
  lightBg: '#ffffff',
  white: '#ffffff',
  whiteOpacity: 'rgba(255, 255, 255, 0.8)',
  blackOpacity: 'rgba(0, 0, 0, 0.8)',
  blackCardOpacity: 'rgba(0,0,0,0.4)',
  whiteCardOpacity: 'rgba(255,255,255,0.4)',
  black: '#000',
  darkGray: '#303030',
  darkGrey: '#333333',
  lightGrey: '#e9e9e9',
  lightGray: '#ddd',
  lightSilver: '#888b90',
  darkBorder: '#ccc',
  lightBorder: '#555',
  subHeaderDark: '#242424',
  subHeaderLight: '#FBFBFB',
  shadowDark: '#333',
  shadowLight: '#eee',
  loginbgb: '#1d1003',
  loginbgw: '#ffd7cb',
  grad1: '#7e39ff',
  grad2: '#3172fd',
};
export const theme: {
  light: { COLORS: any };
  dark: { COLORS: any };
} = {
  dark: {
    COLORS: {
      background: COLORS.darkBg,
      bgColor: COLORS.black,
      drawerBgColor: COLORS.drawerBg,
      mdrawerBgColor: '#343140',
      tradeBG: '#050528',
      opacityBgColor: COLORS.blackOpacity,
      descBox: COLORS.darkBox,
      textsilver: COLORS.lightSilver,
      gray: COLORS.darkGray,
      grey: COLORS.darkGrey,
      textw: COLORS.white,
      textGrey: COLORS.textLightGrey,
      textGray: COLORS.textLightGrey,
      borderColor: COLORS.lightBorder,
      header: COLORS.darkGray,
      subHeader: COLORS.subHeaderDark,
      shadow: COLORS.shadowDark,
      cardOpacity: COLORS.blackCardOpacity,
      content: '#ddd',
      stroke: '#2F2F2F',
      Secondary: '#EFEFEF',
      Tertiary: '#707A8A',
      onSecondary: '#CBD1D7',
      onTertiary: '#000000',
      fail_sub: '#37A16A1A',
      Prinary: '#ffffff',
      raise_sub: '#37A16A1A',
      point: '#00499F',
      complementary: '#1D1D1D',
      fail: '#F6465D',
      raise: '#2EBD85',
      descBorder: COLORS.darkBorder,

      tabMenuActive: '#F87943',
      tabMenuInactive: '#83838C',
      tabMenuMobileBorder: '#333333',
      tabMenuHover: '#3D3D3D',

      descText: '#9897A0',
      listIconBorder: '#1f1f1f',
      listIconBackground: '#333',
      itemTitle: '#fff',
      itemContent: '#C8C8D2',
      itemSubTitle: '#F5F5F5',

      tableBg: '#191a19',
      searchText: '#757575',
      tableBtn: '#474747',
      sectionDesc: '#B5B5BC',

      positiveItem: '#0DCB81',

      memuHover: '#FF4C00',
      subMenuHover: '#333',

      gridBorder: '#272B38',
      numberText: '#EAECEF',
      transactionTableBorder: '#303030',
      mobileTradeBorder: '#5D5D5D',
    },
  },
  light: {
    COLORS: {
      background: COLORS.lightBg,
      drawerBgColor: '#FAFAFA',
      mdrawerBgColor: COLORS.white,
      tradeBG: COLORS.white,
      opacityBgColor: COLORS.whiteOpacity,
      descBox: COLORS.darkBoxOpacity,
      bgColor: COLORS.white,
      textsilver: COLORS.lightSilver,
      gray: COLORS.lightGray,
      grey: COLORS.lightGrey,
      textw: COLORS.black,
      textGrey: COLORS.textLightGrey,
      textGray: COLORS.textLightGrey,
      borderColor: COLORS.darkBorder,
      header: COLORS.white,
      subHeader: COLORS.subHeaderLight,
      shadow: COLORS.shadowLight,
      cardOpacity: COLORS.whiteCardOpacity,
      content: '#999',
      onTertiary: '#F2F4F6',
      fail_sub: '#37A16A1A',
      fail: '#F71053',
      raise: '#37A16A',
      raise_sub: '#37A16A1A',
      stroke: '#EAEAEA',
      onSecondary: '#EDEFF1',
      Prinary: '#303030',
      point: '#00499F',
      Tertiary: '#848E9C',
      Secondary: '#3A3A3A',
      descBorder: COLORS.lightBorder,

      tabMenuActive: '#F87943',
      tabMenuInactive: '#BDBDBD',
      tabMenuMobileBorder: '#EFD9D0',
      tabMenuHover: '#f5f5f5',

      descText: '#9E9E9E',
      listIconBorder: '#F6E8E5',
      listIconBackground: '#F3E2DD',
      itemTitle: '#212121',
      itemContent: '#616161',
      itemSubTitle: '#424242',

      tableBg: '#F6EDEA',
      searchText: '#757575',
      tableBtn: '#EFD6C8',
      sectionDesc: '#757575',

      positiveItem: '#0DCB81',

      memuHover: '#FF4C00',
      subMenuHover: '#EFD6C8',

      gridBorder: '#E2E5EE',
      numberText: '#202630',
      transactionTableBorder: '#ddd',
      mobileTradeBorder: '#ddd',
    },
  },
};
